import AbstractBlock from './abstractBlock.js';

export default class RequestErrorBlock extends AbstractBlock {
    /**
     * Инициализируем поведение
     *
     * @param {jquery} element
     */
    init(element) {
        this.element = element.find('.js-enter_info_request_error');
        if (this.hasElement) {
            console.log('Request Error Block inited');
        } else {
            console.warn('Request Error Block no element');
            return;
        }

        this.element
            .on('click', '.js-resend', ::this.resend)
            .on('click', '.js-cancel', ::this.cancel);
    }

    resend() {
        this.events.trigger('resend');
    }

    cancel() {
        this.events.trigger('cancel');
    }
}
